import { EVatType } from '../../../../shared/types/EVatType';
/**
 * @todo Заменить этот файл на vat-type.js, а тот удалить
 * @description Данный функционал появился в задаче CD-142982, будет удалён в задаче CD-143177
 */
export default [
  {
    text: 'НДС включен',
    value: EVatType.Included,
  },
  {
    text: 'НДС не облагается',
    value: EVatType.NotIncluded,
  },
  {
    text: 'УСН (упрощенная система налогообложения)',
    value: EVatType.Usn,
  },
];
